import React from 'react'

import { getErrorMessage } from 'utils'

import { useSnackbar } from 'contexts'
import {PaymentMethod} from 'services/billingApi'
import {useDeletePaymentMethod} from 'hooks/api'

import {Stack, Typography} from '@mui/material'

import { Modal } from '@repo/ui'
import { Button } from '@repo/ui'



interface DeletePaymentMethodModalProps {
  paymentMethod: PaymentMethod | null,
  open: boolean
  onClose: () => void
  refetch: () => Promise<unknown> | void
}

export const DeletePaymentMethodModal = (props: DeletePaymentMethodModalProps) => {
  const { paymentMethod, open, onClose = () => {}, refetch } = props
  const { open: notification } = useSnackbar()

  const deletePaymentMethod = useDeletePaymentMethod()

  const handleDeletePaymentMethod = async () => {
    if (!paymentMethod) return

    try {
      await deletePaymentMethod.mutateAsync(paymentMethod.id)
      handleClose()
      await Promise.resolve(refetch())
    } catch (error) {
      const message = getErrorMessage(error)
      notification({
        type: 'error',
        title: message,
      })
    }
  }

  const handleClose = () => {
    onClose()
  }

  const paymentLabel = paymentMethod?.label ||
    (paymentMethod
      ? `${(paymentMethod.brand || 'Card').toUpperCase()} •••• ${paymentMethod.last4}`
      : '')

  return (
    <Modal
      title="Delete payment method"
      open={open}
      onClose={handleClose}
      actions={
        <>
          <Button
            disableElevation
            variant="secondary"
            onClick={() => handleClose()}
          >
            Cancel
          </Button>

          <Button
            disableElevation
            destructive
            disabled={!paymentMethod || deletePaymentMethod.isPending}
            onClick={() => handleDeletePaymentMethod()}
          >
            Delete
          </Button>
        </>
      }
    >
      <Stack spacing={4}>
        <Typography variant="body2" color="text.secondary" sx={{lineHeight: 1.5}}>
          {paymentMethod
            ? `Are you sure you want to delete the payment method "${paymentLabel.trim()}"?`
            : 'Are you sure you want to delete this payment method?'}
        </Typography>
      </Stack>
    </Modal>
  )
}
